/**
 * @module ol/format/FormatType
 */
/**
 * @enum {string}
 */
export default {
    ARRAY_BUFFER: 'arraybuffer',
    JSON: 'json',
    TEXT: 'text',
    XML: 'xml'
};
//# sourceMappingURL=FormatType.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/format/FormatType.js
// module id = 103
// module chunks = 1